import { useEffect, useState } from 'react';
import { Box, Button, Center, Column, Text } from '~/commonComponents';

interface IInputReferralLinkProps {
  shortLink?: string;
  isLinkingSuccess: boolean;
  isLoading: boolean;
  onSubmit: (referralLink: string) => void;
  errorMessage?: string;
}

export const InputReferralLink = ({
  shortLink,
  isLinkingSuccess,
  isLoading,
  onSubmit,
  errorMessage,
}: IInputReferralLinkProps) => {
  const [referralLink, setReferralLink] = useState('');

  useEffect(() => {
    if (shortLink) {
      setReferralLink(shortLink);
    }
  }, [shortLink]);

  const handleSubmit = () => {
    onSubmit(referralLink);
  };

  return (
    <Column marginTop={32}>
      {isLinkingSuccess && (
        <Center gap={12}>
          <Text color="primary_500" fontSize={18} bold>
            Referral Link Submitted!
          </Text>
          <Text color="neutral_500">
            Your friend’s referral link has been submitted successfully!
          </Text>
        </Center>
      )}
      {!isLinkingSuccess && (
        <>
          <Text bold color="neutral_600" fontSize={18} marginBottom={10} marginLeft={2}>
            Enter and Submit Their Referral
          </Text>
          <Column>
            <input
              className="input-field"
              style={{ margin: 0, width: '380px', borderRadius: 10 }}
              type="text"
              value={referralLink}
              onChange={(e) => setReferralLink(e.target.value)}
              placeholder="Enter Referral Link"
            />
            <Box height={16} marginTop={4} marginBottom={32}>
              {errorMessage && (
                <Text color="error_500" fontSize={14} marginLeft={2}>
                  {errorMessage}
                </Text>
              )}
            </Box>
          </Column>
          <Center>
            <Button
              text="Submit Referral Link"
              style={{ width: 258, height: 48 }}
              onClick={handleSubmit}
              isLoading={isLoading}
              disabled={isLoading}
            />
          </Center>
        </>
      )}
    </Column>
  );
};
